import { logging } from 'protractor';
import { UserPreferenceConstants } from './../../../../core/constants/user-preference-constants.constant';
import { DataTablePreference } from '../../../../core/models/user-preference';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommonDataService } from './../../../../core/services/common-data.service';
import { DeliveryOrderService } from '../../services/delivery-order.service';
import { BookingService } from './../../services/booking.service';
import { deepCopy, getDataScopeByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { finalize } from 'rxjs/operators';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { PageInfo } from 'src/app/core/models/page-info';
import { DetailPageInfo } from 'src/app/core/models/detail-page-info';

import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { Table } from 'primeng/table';
import { OptionsMappingPipe } from 'src/app/shared/pipes/options-mapping.pipe';
import * as xlsx from 'xlsx';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { LeaveWarehouseService } from '../../services/leave-warehouse.service';
import { TranslateService } from '@ngx-translate/core';
import { LaasCalenderComponent } from 'src/app/features/setting/pages/laas-calender/laas-calender.component';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';

@Component({
  selector: 'leave-warehouse',
  templateUrl: './leave-warehouse.component.html',
  styleUrls: ['./leave-warehouse.component.scss']
})
export class LeaveWarehouseComponent extends SessionBaseComponent implements OnInit {

  @ViewChild(Table) tableComponent!: Table;
  readonly preferenceKey: string;
  readonly detailPreferenceKey: string;
  readonly permissionCode = PermissionConstants.ViewLeaveWarehouse;
  readonly defaultSearchParams: any;
  @ViewChild('signatureDt') signatureDt!: CalendarComponent;
  isSearchFormOpen: boolean;
  isShowEditDOModal: boolean;
  isLoading: boolean;
  columns: any[];
  detailColumns: any[];
  leaveWarehouseRows: any[];
  leaveWarehouseDetailRows: any[];
  selectLeaceWarehouse: any;
  currentLang: string = this.laasSetting.language;
  searchParams: any;

  searchForm: FormGroup;

  pageInfo: PageInfo;
  detailPageInfo: DetailPageInfo;

  sortInfo: { property: string, direction: number } | null;
  detailSortInfo: { property: string, direction: number } | null;

  bookingForwarderList: any[];
  statusOptions: any[];
  selectedCols: any[];
  detailSelectedCols: any[];

  //translate label : Download File
  transLabel: any;

  mainItemMenus: MenuItem[];

  constructor(
    injector: Injector,
    private dropdownOptionsService: DropdownOptionsService,
    private fb: FormBuilder,
    private bookingService: BookingService,
    private leaveWarehouseService: LeaveWarehouseService,
    private translate: TranslateService) {
    super(injector);

    this.bookingForwarderList = [];
    this.statusOptions = [];


    this.preferenceKey = UserPreferenceConstants.LeaveWarehouseSearch;
    this.detailPreferenceKey = UserPreferenceConstants.LeaveWarehouseDetailSearch;

    this.defaultSearchParams = {
      leaveWarehouseKeyList: [],
      carTripList: [],
      status: null,
      bookingForwarderList: [],
      licensePlateList: [],
      doNoList: [],
      signatureDtStart: null,
      signatureDtEnd: null
    };

    this.isSearchFormOpen = true;
    this.isLoading = false;
    this.isShowEditDOModal = false;
    this.columns = [
      { field: 'leaveWarehouseKey', header: 'LeaveWarehouse.Form.LeaveWarehouseKey', sort: true },
      { field: 'facility', header: 'LeaveWarehouse.Form.Facility', sort: true },
      { field: 'status', header: 'LeaveWarehouse.Form.Status', sort: true },
      { field: 'scanType', header: 'LeaveWarehouse.Form.ScanType', sort: true },
      { field: 'carTrip', header: 'LeaveWarehouse.Form.CarTrip', sort: true },
      { field: 'licensePlate', header: 'LeaveWarehouse.Form.LicensePlate', sort: true },
      { field: 'createUser', header: 'LeaveWarehouse.Form.CreateUser', sort: true },
      { field: 'createDt', header: 'LeaveWarehouse.Form.CreateDt', sort: true },
      { field: 'updateUser', header: 'LeaveWarehouse.Form.UpdateUser', sort: true },
      { field: 'updateDt', header: 'LeaveWarehouse.Form.UpdateDt', sort: true },
      { field: 'bookingForwarder', header: 'BookingSearch.Form.Forwarder', sort: true },
      { field: 'cntCaseNormal', header: 'LeaveWarehouse.Form.CntCaseNormal', sort: true },
      { field: 'cntCaseDrop', header: 'LeaveWarehouse.Form.CntCaseDrop', sort: true },
      { field: 'cntCase', header: 'LeaveWarehouse.Form.CntCase', sort: true },
      { field: 'cntBooking', header: 'LeaveWarehouse.Form.CntBooking', sort: true },
      { field: 'signatureDt', header: 'LeaveWarehouse.Form.SignatureDt', sort: true }
    ];

    this.detailColumns = [
      { field: 'dropId', header: 'LeaveWarehouse.DetailForm.DropId', sort: true },
      { field: 'doNo', header: 'LeaveWarehouse.DetailForm.DoNo', sort: true },
      { field: 'outerCaseId', header: 'LeaveWarehouse.DetailForm.OuterCaseId', sort: true },
      { field: 'expectedCaseCount', header: 'LeaveWarehouse.DetailForm.ExpectedCaseCount', sort: true }
    ];

    const dataTablePreference = this.getDataTablePreference(this.preferenceKey)
    this.selectedCols = this.columns;
    this.sortInfo = isNullOrEmpty(dataTablePreference?.state?.sortField) || isNullOrEmpty(dataTablePreference?.state?.sortOrder) ? null :
      { property: dataTablePreference?.state?.sortField, direction: dataTablePreference?.state?.sortOrder };


    const detailTablePreference = this.getDataTablePreference(this.detailPreferenceKey);
    this.detailSelectedCols = this.detailColumns;
    this.detailSortInfo = isNullOrEmpty(detailTablePreference?.state?.sortField) || isNullOrEmpty(detailTablePreference?.state?.sortOrder) ? null :
      { property: detailTablePreference?.state?.sortField, direction: detailTablePreference?.state?.sortOrder };


    this.leaveWarehouseRows = [];
    this.leaveWarehouseDetailRows = [];
    this.searchParams = deepCopy(this.defaultSearchParams);
    this.searchForm = this.fb.group({
      leaveWarehouseKeyList: [],
      carTripList: [],
      status: null,
      bookingForwarderList: [],
      licensePlateList: [],
      doNoList: [],
      signatureDtStart: null,
      signatureDtEnd: null
    });

    this.pageInfo = { pageSize: 5, pageIndex: 0, totalRecords: 0, totalPages: 0 };

    this.detailPageInfo = { pageSize: 5, pageIndex: 0, totalRecords: 0, totalPages: 0 };


    this.mainItemMenus = []
    this.transLabel = ''
    this.translate.onLangChange.subscribe((e: Event) => {
      this.translationLabel();
    });
    this.translationLabel();

  }

  get dataTablePreference(): DataTablePreference | null {
    return this.userService.preference.dataTablePreferences.find(x => x.tableName === this.preferenceKey) ?? null;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    // TODO LeaveWarehouse
    this.dropdownOptionsService.getForwarderOptions()
    .subscribe({
      next: result => {
        this.bookingForwarderList = result;
      }
    });

    this.dropdownOptionsService.getLeaveWarehouseStatusOptions()
    .subscribe({
      next: (options: any[]) => {
        this.statusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionsService.getDocumentTypeOptionsByCategories([4])
    .subscribe({
      next: (options: any[]) => {
        this.mainItemMenus = [{
          label: '',
          items: []
        }];
        this.mainItemMenus[0].label = this.transLabel

        const menuItems = options.map(x => {
          const menu = {
            label: x.optionDesc,
            state: { docType: x.optionCode },
            command: (event: any) => {
              const docType = event.item.state.docType;

              var leaveWarehouseKey: string[] = [];

              if (!isNullOrEmpty(this.selectLeaceWarehouse)) {
                leaveWarehouseKey = [this.selectLeaceWarehouse.leaveWarehouseKey];
              }
              var remark = "";
              this.downloadShippingDocuments(docType, "LeaveWarehouseKey", leaveWarehouseKey,remark);
            }
          };
          return menu;
        });
        if (this.mainItemMenus.length > 0) {
          this.mainItemMenus[0].items = menuItems;
        }
      }
    });



  }

  /**
   * Search form search button click event.
   * @param event Button click event.
   */

  searchBtnClick(event?: any): void {
    this.pageInfo.pageIndex = 0;
    this.loadLeaveWarehouseDataTable(this.pageInfo.pageIndex, this.pageInfo.pageSize, this.sortInfo);

    // 需把Detail table清空
    this.selectLeaceWarehouse = null;
    this.detailPageInfo = { pageSize: 5, pageIndex: 0, totalRecords: 0, totalPages: 0 };
    this.loadDetailLeaveWarehouseDataTable(this.detailPageInfo.pageIndex, this.detailPageInfo.pageSize, this.detailSortInfo);
  }


  /**
   * Search form reset button click event.
   * @param event Button click event.
   */
  resetBtnClick(event: any): void {
    this.signatureDt.ngOnInit();
    this.searchForm.reset();
    this.searchParams.signatureDtStart = null;
    this.searchParams.signatureDtEnd = null;
  }

  /**
   * Datatable paging event.
   * @param event p-table onPage event.
   */
  tablePageChange(event: any): void {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.loadLeaveWarehouseDataTable(this.pageInfo.pageIndex, this.pageInfo.pageSize, this.sortInfo);
  }

  detailTablePageChange(event: any, ): void {
    this.detailPageInfo.pageSize = event.rows;
    this.detailPageInfo.pageIndex = event.first / this.detailPageInfo.pageSize;
    this.loadDetailLeaveWarehouseDataTable(this.detailPageInfo.pageIndex, this.detailPageInfo.pageSize, this.detailSortInfo);
  }

  tableSort(event: any): void {
    this.sortInfo = { property: event.field, direction: event.order };
    this.loadLeaveWarehouseDataTable(this.pageInfo.pageIndex, this.pageInfo.pageSize, this.sortInfo);
  }

  detailTableSort(event: any): void {
    this.detailSortInfo = { property: event.field, direction: event.order };
    this.loadDetailLeaveWarehouseDataTable(this.detailPageInfo.pageIndex, this.detailPageInfo.pageSize, this.detailSortInfo);
  }

  parameterGroupChange(event: any): void {
    if (isNullOrEmpty(event)) {
      this.searchParams = deepCopy(this.defaultSearchParams);
      this.searchForm.patchValue(this.searchParams);
      this.signatureDt.ngOnInit();
    } else {
      this.searchParams = { ...event.data };
      this.searchForm.patchValue(this.searchParams, { emitEvent: false });
      const sStart = this.searchParams.signatureDtStart ? new Date(this.searchParams.signatureDtStart) : null;
      const sEnd = this.searchParams.signatureDtEnd ? new Date(this.searchParams.signatureDtEnd) : null;
      this.signatureDt.syncUIFromOutside([sStart, sEnd]);
    }
  }

  unBookmarked(event: any): void {
    this.searchParams = deepCopy(this.defaultSearchParams);
    this.signatureDt.ngOnInit();
  }

  // translate "download file" word
  translationLabel(){
    this.translateService.get('LeaveWarehouse.Button.DownloadFile').subscribe((translated: string) =>{
      this.transLabel = this.translateService.instant('LeaveWarehouse.Button.DownloadFile');
    });
  }


  private loadLeaveWarehouseDataTable(pageIndex: number | null, pageSize: number | null, sort?: any): void {

    const params = deepCopy(this.searchParams);
    params.pageIndex = pageIndex;
    params.pageSize = pageSize;
    params.sortOrderList = isNullOrEmpty(sort) ? null : [sort];
    params.signatureDtStart = isNullOrEmpty(params.signatureDtStart) ? null : new Date(params.signatureDtStart).toISOString();
    params.signatureDtEnd = isNullOrEmpty(params.signatureDtEnd) ? null : new Date(params.signatureDtEnd).toISOString();
    params.timeZone = this.laasSetting.facilityTimeZone;
    params.facilityList = [this.laasSetting.facility];
    this.isLoading = true;
    this.leaveWarehouseService.queryLeaveWarehouseHeaderPortal(params)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: result => {
          this.isSearchFormOpen = false;
          this.leaveWarehouseRows = result.content.map((x: any) => {
            return x;
          });

          this.pageInfo.totalRecords = result.totalElements;
          this.pageInfo.totalPages = result.totalPages;

       },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        }
    });

  }

  searchDetailClick(event: any, rowData: any): void {

    this.selectLeaceWarehouse = rowData;
    this.loadDetailLeaveWarehouseDataTable(this.detailPageInfo.pageIndex, this.detailPageInfo.pageSize, this.detailSortInfo);

  }


  private loadDetailLeaveWarehouseDataTable(pageIndex: number | null, pageSize: number | null, sort?: any): void {

    this.detailPageInfo.pageIndex = 0;

    const queryLeaveWhDetailPortalRequest = {
      leaveWarehouseKey: isNullOrEmpty(this.selectLeaceWarehouse) ? null : this.selectLeaceWarehouse.leaveWarehouseKey,
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortOrderList: isNullOrEmpty(sort) ? null : [sort]
    };

    this.isLoading = true;
    this.leaveWarehouseService.queryLeaveWarehouseDetailPortal(queryLeaveWhDetailPortalRequest)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: result => {
          this.isSearchFormOpen = false;
          this.leaveWarehouseDetailRows = result.content.map((x: any) => {
            return x;
          });

          this.detailPageInfo.totalRecords = result.totalElements;
          this.detailPageInfo.totalPages = result.totalPages;

       },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        }
    });

  }

  private downloadShippingDocuments(docType: string, referenceType: string, leaveWarehouseKeys: string[], remark: string): void {

    this.isLoading = true;
    this.bookingService.downloadShippingDocuments(docType, referenceType, leaveWarehouseKeys, this.userProfile.loginAccount, false, remark)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (results: any[]) => {
          if (results.length === 0 ||
            results[0].attachFileDetailBeans.length === 0 ||
            isNullOrEmpty(results[0].attachFileDetailBeans[0].file) ||
            isNullOrEmpty(results[0].attachFileDetailBeans[0].fileName)) {
              //無檔案可下載
              this.translateService.get('LeaveWarehouse.Info')
              .subscribe({
                next: result => {
                  this.toastService.info(result);
                }
              });

            return;
          }

          // 重產出倉單要重整表格但不列印
          if (docType == 'ReGenLeaveWarehouse') {
            this.loadLeaveWarehouseDataTable(this.pageInfo.pageIndex, this.pageInfo.pageSize, this.sortInfo);
            return
          }

          const fileInfo = results[0].attachFileDetailBeans[0];
          const byteStr = atob(fileInfo.file);
          const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
          const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteStr.length; i++) {
            int8Array[i] = byteStr.charCodeAt(i);
          }
          const data: Blob = new Blob(
            [int8Array]
          );
          const url = URL.createObjectURL(data);
          const linkEle = document.createElement('a');
          linkEle.href = url;
          linkEle.download = fileInfo.fileName;
          linkEle.click();
          URL.revokeObjectURL(url);
          linkEle.remove();
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err);
        }
      });
  }

  dateOnChange(date: any,type:string) {
    switch(type){
      case "SignatureDt" :
        this.searchParams.signatureDtStart = date.startDate;
        this.searchParams.signatureDtEnd = date.endDate;
        break;
    }
  }

  showDateOnChange(event: any) {
    if (!isNullOrEmpty(event.data.signatureDtStart)) {
      const signatureDtStart = new Date(event.data.signatureDtStart);
      if (isNullOrEmpty(event.data.signatureDtEnd)) {
        this.signatureDt.changeSelectMode('Start');
        //change mode 完會延遲200ms clear date
        setTimeout(() => {
          this.signatureDt.changeShowDate(signatureDtStart);
        }, 400);
      } else {
        this.signatureDt.changeSelectMode('Range');
        setTimeout(() => {
          this.signatureDt.changeShowDate([signatureDtStart, new Date(event.data.signatureDtEnd)]);
        }, 400);
      }
    }
  }

  setPageSize(event: any): void {
    this.pageInfo.pageSize = event.rows;
  }
}
